exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.CodeMirror[data-v-a19e918e] {\n  border-radius: 4px;\n}\n.vue-codemirror[data-v-a19e918e] {\n  width: 100%;\n}\n.dialog-code[data-v-a19e918e] {\n  position: relative;\n  padding: 0;\n  background: white;\n}\n.close[data-v-a19e918e] {\n  position: absolute;\n  right: 20px;\n  top: 16px;\n  z-index: 1;\n  font-size: 24px;\n  color: #c3c6d5;\n}\n", ""]);

// exports
